import { NavigationEffects } from './navigation.effects';
import { UserEffects } from './user.effects';

export const AppEffects = [NavigationEffects, UserEffects];
